import blocks from './blocks';
import headline from './headline';
import timeline from './timeline';
import parallax from './parallax';

const initialize = () => {

    headline.initialize();
    blocks.initialize();
    timeline.initialize();
    parallax.initialize();
};

export default {
    initialize,
};

